import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionCeseTRADEByID = () => {
  const [loadingUpdateDeclaracionCeseTRADEById, setLoadingCreateDeclaracionCeseTRADE] = useState(false);
  const [successUpdateDeclaracionCeseTRADEById, setSuccessCreateDeclaracionCeseTRADE] = useState(false);
  const [errorUpdateDeclaracionCeseTRADEById, setErrorCreateDeclaracionCeseTRADE] = useState(null);
  const [dataUpdateDeclaracionCeseTRADEById, setDataDeclaracionCeseTRADE] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateDeclaracionCeseTRADEById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateDeclaracionCeseTRADE(true);
    setSuccessCreateDeclaracionCeseTRADE(false);
    setErrorCreateDeclaracionCeseTRADE(null);

    apiRecord.updateSolicitudDeclaracionJuradaTradeByID(userId, formId, data).then((res: any) => {
      setLoadingCreateDeclaracionCeseTRADE(false);
      setSuccessCreateDeclaracionCeseTRADE(true);
      setDataDeclaracionCeseTRADE(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateDeclaracionCeseTRADE(false);
      setErrorCreateDeclaracionCeseTRADE(err.response.data)
    })
  }

  return {
    updateDeclaracionCeseTRADEById,
    loadingUpdateDeclaracionCeseTRADEById,
    successUpdateDeclaracionCeseTRADEById,
    errorUpdateDeclaracionCeseTRADEById,
    dataUpdateDeclaracionCeseTRADEById
  }

}

export default useUpdateDeclaracionCeseTRADEByID;
